/* hs-eslint ignored failing-rules */
/* eslint-disable @typescript-eslint/no-floating-promises */

import { memo, useCallback, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { CONTACT, CONVERSATION, COMPANY as COMPANY_OBJECT_TYPE } from 'customer-data-objects/constants/ObjectTypes';
import { trackEvent } from '../../usage-tracking/clients/usageTracker';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'cust... Remove this comment to see the full error message
import UniversalSidebar from 'customer-data-sidebar/universal/UniversalSidebar';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'cust... Remove this comment to see the full error message
import UniversalSidebarHighlight from 'customer-data-sidebar/universal/highlight/UniversalSidebarHighlight';
import { client } from '../../graphql/client';
import { CONVERSATIONS_INBOX, BASIC_SIDEBAR
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'cust... Remove this comment to see the full error message
} from 'customer-data-sidebar/universal/cardLocationConstants';
import { useConversationIdByThreadId } from '../../crm-integration/hooks/useConversationIdByThreadId';
import { CONVERSATIONS } from '../constants/AppSource';
import { getCanonicalVid, getVid } from 'conversations-inbox-lib/contacts/public/operators';
import { isKnownContact } from '../../contacts/operators/isKnownContact';
import { useSidebarCardProps } from '../../crm-sidebar-cards/hooks/useSidebarCardProps';
import { getSidebarCards } from '../../crm-sidebar-cards/render-helpers/getSidebarCards';
import { getEditedContactRecord } from '../constants/Events';
import { getAuth } from '../../auth/selectors/getAuth';
import { FIRST_NAME, LAST_NAME, JOB_TITLE, COMPANY } from 'conversations-inbox-lib/contacts/public/constants';
import { refreshVisitor } from 'find-and-filter-data/visitors/public';
import styled from 'styled-components';
import { ObjectTypesToIds } from 'customer-data-objects/constants/ObjectTypeIds';
import updateCalleeNumber from 'calling-global-api/methods/updateCalleeNumber';
import { getIsUngatedForLimitedTicketFunctionality } from '../../selectors/gateSelectors';
import { jsx as _jsx } from "react/jsx-runtime";
const StyledPreviewHighlight = styled.div.withConfig({
  displayName: "ConnectedCrmSidebar__StyledPreviewHighlight",
  componentId: "sc-14dbb26-0"
})(["margin-bottom:-24px;"]);
const PHONE_NUMBER_PROPERTY = 'phone';
const PreviewHighlight = props => {
  return /*#__PURE__*/_jsx(StyledPreviewHighlight, {
    children: /*#__PURE__*/_jsx(UniversalSidebarHighlight, Object.assign({}, props))
  });
};
PreviewHighlight.displayName = 'PreviewHighlight';

// contact properties that should invalidate visitors - these should be properties
// that we see throughout the inbox that are obvious and expected to be updated on changes
export const VISIBLE_CONTACT_PROPERTIES = [FIRST_NAME, LAST_NAME, JOB_TITLE, COMPANY];
/**
 * ConnectedCrmSidebar
 *
 * The interface for connecting to the `Sidebar`
 * This will ensure direct data dependencies are fulfilled so only handlers/helpers need to be supplied
 */
const ConnectedCrmSidebar = ({
  openCreateTicketModal,
  contact,
  isThreadFiltered,
  isThreadSoftDeleted,
  renderCustomHighlight,
  threadId
}) => {
  const dispatch = useDispatch();
  const auth = useSelector(getAuth);
  const isUngatedForLimitedTicketFunction = useSelector(getIsUngatedForLimitedTicketFunctionality);
  const authData = useMemo(() => ({
    gates: auth.gates,
    portal: auth.portal,
    user: auth.user
  }), [auth]);
  const handleObjectUpdate = useCallback(({
    objectId,
    objectType,
    properties
  }) => {
    if (objectType === CONTACT) {
      properties.forEach((_, fieldName) => trackEvent(getEditedContactRecord({
        fieldName
      })));
      const isVisibleUpdate = properties.keySeq().some(field => VISIBLE_CONTACT_PROPERTIES.includes(field));
      if (isVisibleUpdate) {
        dispatch(refreshVisitor({
          vid: getVid(contact),
          threadId: Number(threadId)
        }));
      }
    }
    if (window.hsCalling && window.hsCalling.updateCalleeNumber) {
      const contactOrCompanyUpdate = objectType === CONTACT || objectType === COMPANY_OBJECT_TYPE;
      if (contactOrCompanyUpdate && properties && properties.has(PHONE_NUMBER_PROPERTY)) {
        // @ts-expect-error ts-migrate(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
        const objectTypeId = ObjectTypesToIds[objectType] || objectType;
        updateCalleeNumber({
          objectId: Number(objectId),
          objectTypeId,
          rawValue: properties.get(PHONE_NUMBER_PROPERTY),
          property: PHONE_NUMBER_PROPERTY
        });
      }
    }
  }, [contact, dispatch, threadId]);
  let objectType = CONTACT;
  let subjectId = contact && `${getCanonicalVid(contact)}`;
  const {
    conversationId
  } = useConversationIdByThreadId({
    threadId
  });
  const hasConversationId = Boolean(conversationId) && !isThreadFiltered && !isThreadSoftDeleted;
  const cardComponents = useMemo(() => getSidebarCards({
    shouldRenderTicketCards: hasConversationId,
    isUngatedForLimitedTicketFunction
  }), [hasConversationId, isUngatedForLimitedTicketFunction]);

  // If the visitor is unknown, the sidebar subject is the conversation
  if (!isKnownContact(contact)) {
    objectType = CONVERSATION;
    subjectId = threadId;
  }
  const cardProps = useSidebarCardProps({
    openCreateTicketModal,
    contact,
    conversationId,
    subjectId,
    threadId
  });
  if (!auth) {
    return null;
  }
  return /*#__PURE__*/_jsx(UniversalSidebar, {
    apolloClient: client,
    auth: authData,
    cardComponents: cardComponents,
    HighlightComponent: renderCustomHighlight,
    cardProps: cardProps,
    cardLocation: CONVERSATIONS_INBOX,
    previewCardLocation: BASIC_SIDEBAR,
    PreviewHighlightComponent: PreviewHighlight,
    objectType: objectType,
    onObjectUpdate: handleObjectUpdate,
    subjectId: subjectId,
    sourceApp: CONVERSATIONS
  });
};
ConnectedCrmSidebar.displayName = 'ConnectedCrmSidebar';
export default /*#__PURE__*/memo(ConnectedCrmSidebar);